import { IAddNotificationsAction, IClearNotificationsAction } from './notificationsActions';

export type NotificationsActionTypes = IAddNotificationsAction | IClearNotificationsAction;

export enum NotificationsActionTypeKeys {
    ADD_NOTIFICATION = 'NOTIFICATIONS/ADD_NOTIFICATION',
    CLEAR_NOTIFICATIONS = 'NOTIFICATIONS/CLEAR_NOTIFICATIONS'
}


// WEBPACK FOOTER //
// ./src/actions/notificationsActionTypes.ts